import { productCategoryLabel } from '@entities/product/api/product.contract'
import type { Product } from '@entities/product/api/product.contract'

export function mainProductMeta(
  product: Pick<Product, 'category' | 'priceModel' | 'recurrencePlans'>,
) {
  const category = productCategoryLabel(product.category)
  if (product.priceModel !== 'subscription') return category
  const activePlans = product.recurrencePlans.filter((plan) => plan.active)
  if (activePlans.length <= 1) return `${category} · Assinatura`
  return `${category} · Assinatura · ${activePlans.length} planos`
}
